import React from "react";
import { useNavigate } from "react-router-dom";
import FeedLogo from "./FeedLogo";
import CopyableUrl from "./CopyableUrl";
import { buildFeedUrl } from "./feeds.config";

export const FeedCard = ({ channel, enabled, feedUrl, onToggle }) => {
    const navigate = useNavigate();
    const url = feedUrl || buildFeedUrl(channel.slug);

    return (
        <div className="feed-card">
            <div className="feed-card__head">
                <FeedLogo slug={channel.slug} color={channel.color} />
                <label className="feed-switch" title={enabled ? "Desativar feed" : "Ativar feed"}>
                    <input
                        type="checkbox"
                        checked={enabled}
                        onChange={() => onToggle(channel.slug)}
                    />
                    <span className="feed-switch__track" />
                </label>
            </div>

            <span className="feed-card__tag">{channel.category}</span>
            <h3 className="feed-card__name">{channel.name}</h3>
            <p className="feed-card__desc">{channel.description}</p>

            <div className={`feed-card__url${enabled ? "" : " is-disabled"}`}>
                <CopyableUrl url={url} />
            </div>

            <div className="feed-card__footer">
                <span className={`feed-status feed-status--${enabled ? "on" : "off"}`}>
                    <i /> {enabled ? "Ativo" : "Inativo"}
                </span>
                <button
                    type="button"
                    className="feed-card__config"
                    onClick={() => navigate(`/feed/${channel.slug}`)}
                >
                    Configurar
                </button>
            </div>
        </div>
    );
};

export default FeedCard;
